import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import _, { map, compact, isNil, uniq, uniqBy, sortBy, round } from 'lodash'

import Table from 'UI/Table'
import BooleanIcon from 'UI/BooleanIcon'
import VcenterSubMenu from 'FoundationalComponents/AssetSubMenus/Vcenter'
import { VMReportFilters as Filters, filteredData } from './Filters'
import AssetNameWithLabel from 'FoundationalComponents/AssetNameWithLabel'

const toolsLabel = (value) => isNil(value) ? 'No tools information' : value.match(/[A-Z][a-z]+|[0-9]+/g).join(" ").replace('Tools ', '')
const clusterLabel = (value) => isNil(value) ? 'No cluster information' : value

const VcenterAssetReportVMs = ({ vms, locations }) => {
  const [filters, changeFilters] = useState({ locations: 'all', cluster: 'all', powerState: 'all', toolsStatus: 'all', toolsState: 'all', guestOs: 'all' })
  const filterOptions = {
    locations: map(compact(locations), ({ id, name }) => ({ label: name, value: id })),
    toolsStatus: map(sortBy(uniq(map(vms, 'tools_status'))), (toolsStatus) => ({ label: toolsLabel(toolsStatus), value: toolsStatus })),
    toolsState: map(sortBy(uniq(map(vms, 'tools_state'))), (toolsState) => ({ label: toolsLabel(toolsState), value: toolsState })),
    guestOs: map(sortBy(uniq(map(vms, 'guest_os'))), (guestOs) => ({ label: guestOs, value: guestOs })),
    cluster: _(vms)
    .map(vm => [vm.cluster, vm.location_id])
    .uniqBy(([cluster, location_id]) => cluster)
    .sortBy(([cluster, location_id]) => cluster)
    .map(([cluster, location_id]) => (
      {
        label: clusterLabel(cluster),
        value: cluster,
        locationId: location_id
      }
    ))
    .value(),
  }

  const columns = [
    { Header: 'Name', accessor: 'name', width: 300, Cell: ({ value, original }) => (<AssetNameWithLabel name={value} label={original.asset_label} />) },
    {
      Header: 'Location',
      id: 'location_name',
      type: 'list',
      sortable: false,
      accessor: (data) => ([
        { label: 'Location', value: data.location_name },
        { label: 'Cluster', value: data.cluster },
        { label: 'vCenter', value: <VcenterSubMenu vcenter={data.vcenter} /> }
      ])
    },
    {
      Header: 'Power State',
      accessor: 'power_state',
      width: 100,
      Cell: ({ value: powerState }) => (
        <BooleanIcon {...{
          booleanValue: powerState === 'On',
          trueIcon: { text: powerState, icon: 'power-off' },
          falseIcon: { text: powerState, icon: 'power-off' }
        }} />
      ),
      Filter: ({ filter, onChange }) => (
        <select onChange={event => changeFilters({ ...filters, powerState: event.target.value })} style={{ width: "100%" }}>
          <option value="all" selected={'all'}>Show All</option>
          {map(['On', 'Off', 'Unknown'], status => (
            <option value={status} selected={filter && filter.value === status}>{status}</option>
          ))}
        </select>
      )
    },
    { Header: 'Guest OS', accessor: 'guest_os' },
    { Header: 'IP Address', accessor: 'ip_address' },
    { Header: 'vCPU', accessor: 'vcpu', width: 90 },
    { Header: 'Memory', accessor: 'memory', width: 90, Cell: ({ value }) => `${round(value, 2)}GB` },
    { Header: 'Disk Space', accessor: 'disk_space', width: 90, Cell: ({ value }) => `${round(value, 2)}GB` },
    { Header: 'Hardware Version', accessor: 'hardware_version', width: 90 },
    {
      Header: 'Tools',
      id: 'tools',
      type: 'list',
      sortMethod: (a, b) => {
        const status_a = find(a, ['label', 'Status'])
        const status_b = find(b, ['label', 'Status'])

        return (status_a.value > status_b.value ? 1 : -1)
      },
      accessor: (data) => ([
        { label: 'Status', value: toolsLabel(data.tools_status)},
        { label: 'State', value: toolsLabel(data.tools_state)},
        { label: 'Version', value: isNil(data.tools_version) ? 'No tools information' : data.tools_version }
      ])
    },
  ]

  return (
    <Fragment>
      <Filters {...{ filters, changeFilters, filterOptions }} />

      <Table {...{
        data: filteredData({ vms, filters }),
        columns: columns,
        tableProps: {
          defaultSorted: [{ id: 'name', asc: true }],
          filterable: true
        }
      }} />
    </Fragment>
  )
}

export default VcenterAssetReportVMs
